var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Lottie',{staticClass:"confetti",attrs:{"width":_vm.width,"height":_vm.height,"options":_vm.options,"start-animation":_vm.animationSettings.startAnimation,"stop-animation":_vm.animationSettings.stopAnimation,"reverse-animation":_vm.animationSettings.reverseAnimation}})
}
var staticRenderFns = []

export { render, staticRenderFns }